module.exports = __webpack_public_path__ + "static/media/imagem3D.f077ed77.svg";